import React from "react";

import { ArrowUpIcon } from "@pages/casino/assets/icons";

import { ScrollToTopButton } from "./elements.js";
import useController from "./useController.js";

const ScrollToTop = () => {
	const {
		state: { isVisible },
		handlers: { handleClick },
	} = useController();

	if (!isVisible) {
		return null;
	}

	return (
		<ScrollToTopButton
			onClick={handleClick}
			className="scroll-to-top">
			<ArrowUpIcon />
		</ScrollToTopButton>
	);
};

export default ScrollToTop;
